module.exports = __webpack_public_path__ + "assets/static/png/ico-secure.bd86b1f57ed3208fd1e95e244180c9c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/ico-secure.png
 ** module id = 492
 ** module chunks = 1
 **/